<template>
  <div
    v-if="!client.status"
    class="client-status">
    <span
      v-if="showTitle"
      class="client-title">
      OnTag klient
    </span>
    <router-link
      class="client-name"
      :to="'/ontag/ontag-clients/' + (client.displayName ?? '')">
      {{ client.displayName ?? '(Namn saknas)' }}
    </router-link>
    <div class="client-status-icon-container">
      <img
        src="../../assets/images/oval-red.svg"
        alt=""
        class="client-status-icon" />
      <span class="client-status-icon-text">
        {{ $t('OnTagDashboard.error') }}
      </span>
      <div class="client-status-error-text">
        <span>Felsök via </span>
        <a
          href="https://support.golfoffice.se/Media/Get/1494/starta-tjanst-mot-golfoffice"
          target="_blank"
          class="client-status-error-link">
          denna guide
        </a>
        <span class="client-status-info">
          OBS! Det kan ta 2-3 minuter innan klienten ändrar status till online
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    client: Object,
    showTitle: Boolean,
  },
};
</script>

<style scoped>
.client-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-right: 1rem;
  width: 100%;
  min-width: 25rem;
  text-overflow: ellipsis;
  white-space: wrap;
  min-height: fit-content;
}

.client-title {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  border-right: solid 2px rgb(190, 1, 1);
}

.client-name {
  font-weight: 800;
}

.client-status-text {
  display: flex;
  align-items: center;
}

.client-status-icon-container {
  position: relative;
  display: flex;
  align-items: center;
}

.client-status-icon {
  width: 3rem;
  height: 3rem;
}

.client-status-icon-text {
  @include body-tiny();
  position: absolute;
  top: 0.9rem;
  left: 0.9rem;
}

.client-status-error-text {
  margin-left: 12px;
  font-size: 12px;
  font-style: italic;
  font-weight: 800;
}

.client-status-error-link {
  font-size: 14px;
  font-weight: 600;
}
.client-status-info {
  font-size: 12px;
  font-weight: 400;
  padding-left: 0.5rem;
}
</style>
